import axios from "axios";
import { call, put, takeLatest } from "redux-saga/effects";
import { axiosInstance } from "../../../network/apis";
import { GET_MY_CERTIFICATE_URL, GET_SPOT_REWARDS_URL } from "../../../network/apis/apiPath";
import { getLocalStoreString } from "../../../utils/Helper";
import { GET_SPOT_REWARDS_DATA } from "../../type";
import { saveSpotRewardsRequestData } from "./spotRewardsConfigSlice";


function* getSpotRewardsConfigDataWorker() {
    const BearerToken = localStorage.getItem("BearerToken");
    const TenantId = getLocalStoreString("CompanyID");
    const EmployeeCode = getLocalStoreString('EmployeeCode')
    const Headers = {
        Authorization: `Bearer ${BearerToken}`,
        "accept": '*/*',
        "Tenant-Id": TenantId,
    };
    try {
        const response = (yield call(axios.get, `${GET_SPOT_REWARDS_URL}?employeeCode=${EmployeeCode}`, { headers: Headers }));
        if (response) {
            yield put(saveSpotRewardsRequestData(response?.data))
        }

    } catch (error) {
        console.log(error);
    }
}

export function* spotRewardsConfigWatcher() {
    yield takeLatest(GET_SPOT_REWARDS_DATA, getSpotRewardsConfigDataWorker);
}